var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vistor-manage common-bg"},[_c('div',{staticClass:"vistor"},[_c('today-vistor')],1),_c('div',{staticClass:"vistor2"},[_c('foreign-construction')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }